import React from 'react'

const Dinerarias = ({iconContactoMasculino, iconContactoFemenino}) => {
   return (
      <>
         <div className="bg-latitud animated fadeIn" style={{"margin-bottom":"30px"}}>
            <div className="container section center white-text">
               <h5>
                  <strong>Dinerarias</strong>
               </h5>
            </div>
         </div>
         <div className="row">
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                     <span className="black-text">
                        <strong>Nelson Goyochea</strong><br/>
                        0388 - 155 134 705<br/>
                        0388 - 4911741 Int.: 126<br/>
                        salarioscaidos@latitudsursa.com.ar<br/>
                        dinerarias@latitudsursa.com.ar
                     </span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoFemenino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                     <span className="black-text">
                        <strong>Cr. Cintia Alancay</strong><br/>
                        0388 - 155 088 971<br/>
                        0388 - 4911741 Int.: 130<br/>
                        salarioscaidos@latitudsursa.com.ar<br/>
                        calancay@latitudsursa.com.ar
                     </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Dinerarias